// extracted by mini-css-extract-plugin
export default {"close-button":"expandable-image_close-button__bbEZM","image":"expandable-image_image__c0ybe","container-chat-picture":"expandable-image_container-chat-picture__gZB30"};